import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('teams')

export const TEAM_NAME_EDIT_MODE = Object.freeze({
  REVIEW: 'REVIEW',
  EDIT: 'EDIT',
})

export const HOURS_EDIT_MODES = Object.freeze({
  REVIEW: 'REVIEW',
  EDIT: 'EDIT',
})

export const HOURS_AVAILABILITY_MODES = Object.freeze({
  ALWAYS_ONLINE: 'ALWAYS_ONLINE',
  ALWAYS_OFFLINE: 'ALWAYS_OFFLINE',
  CUSTOM_HOURS: 'CUSTOM_HOURS',
})

export const HOURS_MODE_COPY = {
  [HOURS_AVAILABILITY_MODES.ALWAYS_ONLINE]: {
    title: 'Always online',
    description: 'This team will always be online - 24 hours a day, 7 days a week',
  },
  [HOURS_AVAILABILITY_MODES.ALWAYS_OFFLINE]: {
    title: 'Taken Offline',
    description: 'This team will always be offline.',
  },
  [HOURS_AVAILABILITY_MODES.CUSTOM_HOURS]: {
    title: 'Scheduled Online Hours',
    description: 'Team availability is based on custom time slots',
  },
}

export const FETCH_ORG_TEAMS = makeConstant('FETCH_ORG_TEAMS')
export const FETCH_ORG_TEAMS_PENDING = makeConstant('FETCH_ORG_TEAMS_PENDING')
export const FETCH_ORG_TEAMS_SUCCESS = makeConstant('FETCH_ORG_TEAMS_SUCCESS')
export const FETCH_ORG_TEAMS_FAILED = makeConstant('FETCH_ORG_TEAMS_FAILED')

export const FETCH_TEAMS_FOR_USER = makeConstant('FETCH_TEAMS_FOR_USER')
export const FETCH_TEAMS_FOR_USER_PENDING = makeConstant('FETCH_TEAMS_FOR_USER_PENDING')
export const FETCH_TEAMS_FOR_USER_SUCCESS = makeConstant('FETCH_TEAMS_FOR_USER_SUCCESS')
export const FETCH_TEAMS_FOR_USER_FAILED = makeConstant('FETCH_TEAMS_FOR_USER_FAILED')

export const PATCH_ORG_TEAM = makeConstant('PATCH_ORG_TEAM')
export const PATCH_ORG_TEAM_PENDING = makeConstant('PATCH_ORG_TEAM_PENDING')
export const PATCH_ORG_TEAM_SUCCESS = makeConstant('PATCH_ORG_TEAM_SUCCESS')
export const PATCH_ORG_TEAM_FAILED = makeConstant('PATCH_ORG_TEAM_FAILED')

export const DELETE_ORG_TEAM = makeConstant('DELETE_ORG_TEAM')
export const DELETE_ORG_TEAM_PENDING = makeConstant('DELETE_ORG_TEAM_PENDING')
export const DELETE_ORG_TEAM_SUCCESS = makeConstant('DELETE_ORG_TEAM_SUCCESS')
export const DELETE_ORG_TEAM_FAILED = makeConstant('DELETE_ORG_TEAM_FAILED')

export const CREATE_ORG_TEAM = makeConstant('CREATE_ORG_TEAM')
export const CREATE_ORG_TEAM_PENDING = makeConstant('CREATE_ORG_TEAM_PENDING')
export const CREATE_ORG_TEAM_SUCCESS = makeConstant('CREATE_ORG_TEAM_SUCCESS')
export const CREATE_ORG_TEAM_FAILED = makeConstant('CREATE_ORG_TEAM_FAILED')

export const UPDATE_AVAILABILITY_FOR_TEAM = makeConstant('UPDATE_AVAILABILITY_FOR_TEAM')
export const UPDATE_AVAILABILITY_FOR_TEAM_SUCCESS = makeConstant('UPDATE_AVAILABILITY_FOR_TEAM_SUCCESS')
export const UPDATE_AVAILABILITY_FOR_TEAM_PENDING = makeConstant('UPDATE_AVAILABILITY_FOR_TEAM_PENDING')
export const UPDATE_AVAILABILITY_FOR_TEAM_FAILED = makeConstant('UPDATE_AVAILABILITY_FOR_TEAM_FAILED')

export const FETCH_TEAM_AVAILABILITIES = makeConstant('FETCH_TEAM_AVAILABILITIES')
export const FETCH_TEAM_AVAILABILITIES_SUCCESS = makeConstant('FETCH_TEAM_AVAILABILITIES_SUCCESS')
export const FETCH_TEAM_AVAILABILITIES_PENDING = makeConstant('FETCH_TEAM_AVAILABILITIES_PENDING')
export const FETCH_TEAM_AVAILABILITIES_FAILED = makeConstant('FETCH_TEAM_AVAILABILITIES_FAILED')

export const FETCH_TEAM_AVAILABILITY = makeConstant('FETCH_TEAM_AVAILABILITY')
export const FETCH_TEAM_AVAILABILITY_SUCCESS = makeConstant('FETCH_TEAM_AVAILABILITY_SUCCESS')
export const FETCH_TEAM_AVAILABILITY_PENDING = makeConstant('FETCH_TEAM_AVAILABILITY_PENDING')
export const FETCH_TEAM_AVAILABILITY_FAILED = makeConstant('FETCH_TEAM_AVAILABILITY_FAILED')

export const CREATE_TEAM_AVAILABILITY = makeConstant('CREATE_TEAM_AVAILABILITY')
export const CREATE_TEAM_AVAILABILITY_SUCCESS = makeConstant('CREATE_TEAM_AVAILABILITY_SUCCESS')
export const CREATE_TEAM_AVAILABILITY_PENDING = makeConstant('CREATE_TEAM_AVAILABILITY_PENDING')
export const CREATE_TEAM_AVAILABILITY_FAILED = makeConstant('CREATE_TEAM_AVAILABILITY_FAILED')

export const UPDATE_TEAM_AVAILABILITY = makeConstant('UPDATE_TEAM_AVAILABILITY')
export const UPDATE_TEAM_AVAILABILITY_SUCCESS = makeConstant('UPDATE_TEAM_AVAILABILITY_SUCCESS')
export const UPDATE_TEAM_AVAILABILITY_PENDING = makeConstant('UPDATE_TEAM_AVAILABILITY_PENDING')
export const UPDATE_TEAM_AVAILABILITY_FAILED = makeConstant('UPDATE_TEAM_AVAILABILITY_FAILED')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/teams/constants.js